import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack } from '@ui-lib';
import type { ReactNode } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';

import { FieldMessage } from '../FieldMessage/FieldMessage';
import { selectIcon, selectStyle } from './Select.css';

type Size = 'small' | 'medium' | 'large';
type Tone = 'neutral' | 'critical';

interface Props {
  id?: string;
  children: ReactNode;
  size?: Size;
  fullWidth?: boolean;
  message?: string;
  tone?: Tone;
}

type SelectProps = Props & UseFormRegisterReturn;

export const Select = ({
  ref,
  children,
  size = 'medium',
  fullWidth = false,
  id,
  tone,
  message,
  ...rest
}: SelectProps & {
  ref?: React.Ref<HTMLSelectElement>;
}) => (
  <Stack gap="xsmall">
    <div style={{ position: 'relative', display: 'flex', flexGrow: fullWidth ? 1 : undefined }}>
      <select {...rest} className={selectStyle({ size, tone })} ref={ref}>
        {children}
      </select>
      <FontAwesomeIcon className={selectIcon} icon={faAngleDown} />
    </div>
    {message && <FieldMessage id={id} tone={tone} message={message} />}
  </Stack>
);

Select.displayName = 'Select';
